// const FLOOR_5_DATA = [
//   {
//     floor: 5,
//     building: 'B',
//     apartmentNumber: 48,
//     sceneName: 'scene_B48_05_krs',
//     sceneName_2020: 'scene_B48_05_krs_2020',
//     name: 'B48',

//     relatedApartments: { 6: 53 },
//   },
// ]

const FLOOR_6_DATA = [
  {
    floor: 6,
    building: 'B',
    apartmentNumber: 50,
    sceneName: 'scene_B50a_06_krs',
    sceneName_2020: 'scene_B50a_06_krs_2020',
    name: 'B50a',

    relatedApartments: { 7: 55 },
  },
  {
    floor: 6,
    building: 'B',
    apartmentNumber: 51,
    sceneName: 'scene_B51_06_krs',
    sceneName_2020: 'scene_B51_06_krs_2020',
    name: 'B51',

    relatedApartments: { 7: 56 },
  },
  {
    floor: 6,
    building: 'B',
    apartmentNumber: 52,
    sceneName: 'scene_B52_06_krs',
    sceneName_2020: 'scene_B52_06_krs_2020',
    name: 'B52',

    relatedApartments: { 7: 57 },
  },
  {
    floor: 6,
    building: 'B',
    apartmentNumber: 53,
    sceneName: 'scene_B53_06_krs',
    sceneName_2020: 'scene_B53_06_krs_2020',
    name: 'B53',

    relatedApartments: { 7: 58 },
  },
]

const FLOOR_7_DATA = [
  {
    floor: 7,
    building: 'B',
    apartmentNumber: 55,
    sceneName: 'scene_B55a_07_krs',
    sceneName_2020: 'scene_B55a_07_krs_2020',
    name: 'B55a',

    relatedApartments: { 6: 50, 8: 60 },
  },
  {
    floor: 7,
    building: 'B',
    apartmentNumber: 56,
    sceneName: 'scene_B56_07_krs',
    sceneName_2020: 'scene_B56_07_krs_2020',
    name: 'B56',

    relatedApartments: { 6: 51, 8: 61 },
  },
  {
    floor: 7,
    building: 'B',
    apartmentNumber: 57,
    sceneName: 'scene_B57_07_krs',
    sceneName_2020: 'scene_B57_07_krs_2020',
    name: 'B57',

    relatedApartments: { 6: 52, 8: 62 },
  },
  {
    floor: 7,
    building: 'B',
    apartmentNumber: 58,
    sceneName: 'scene_B58_07_krs',
    sceneName_2020: 'scene_B58_07_krs_2020',
    name: 'B58',
    relatedApartments: { 6: 53, 8: 63 },
  },
]

const FLOOR_8_DATA = [
  {
    floor: 8,
    building: 'B',
    apartmentNumber: 60,
    sceneName: 'scene_B60a_08_krs',
    sceneName_2020: 'scene_B60a_08_krs_2020',
    name: 'B60a',

    relatedApartments: { 7: 55, 9: 65 },
  },
  {
    floor: 8,
    building: 'B',
    apartmentNumber: 61,
    sceneName: 'scene_B61_08_krs',
    sceneName_2020: 'scene_B61_08_krs_2020',
    name: 'B61',

    relatedApartments: { 7: 56, 9: 66 },
  },
  {
    floor: 8,
    building: 'B',
    apartmentNumber: 62,
    sceneName: 'scene_B62_08_krs',
    sceneName_2020: 'scene_B62_08_krs_2020',
    name: 'B62',

    relatedApartments: { 7: 57, 9: 67 },
  },
  {
    floor: 8,
    building: 'B',
    apartmentNumber: 63,
    sceneName: 'scene_B63_08_krs',
    sceneName_2020: 'scene_B63_08_krs_2020',
    name: 'B63',
    relatedApartments: { 7: 58, 9: 68 },
  },
]
const FLOOR_9_DATA = [
  {
    floor: 9,
    building: 'B',
    apartmentNumber: 65,
    sceneName: 'scene_B65a_09_krs',
    sceneName_2020: 'scene_B65a_09_krs_2020',
    name: 'B65a',

    relatedApartments: { 8: 60, 10: 70 },
  },
  {
    floor: 9,
    building: 'B',
    apartmentNumber: 66,
    sceneName: 'scene_B66_09_krs',
    sceneName_2020: 'scene_B66_09_krs_2020',
    name: 'B66',

    relatedApartments: { 8: 61, 10: 71 },
  },
  {
    floor: 9,
    building: 'B',
    apartmentNumber: 67,
    sceneName: 'scene_B67_09_krs',
    sceneName_2020: 'scene_B67_09_krs_2020',
    name: 'B67',

    relatedApartments: { 8: 62, 10: 72 },
  },
  {
    floor: 9,
    building: 'B',
    apartmentNumber: 68,
    sceneName: 'scene_B68_09_krs',
    sceneName_2020: 'scene_B68_09_krs_2020',
    name: 'B68',
    relatedApartments: { 8: 63, 10: 73 },
  },
]

const FLOOR_10_DATA = [
  {
    floor: 10,
    building: 'B',
    apartmentNumber: 70,
    sceneName: 'scene_B70a_10_krs',
    sceneName_2020: 'scene_B70a_10_krs_2020',
    name: 'B70a',
    relatedApartments: { 9: 65, 11: 75 },
  },
  {
    floor: 10,
    building: 'B',
    apartmentNumber: 71,
    sceneName: 'scene_B71_10_krs',
    sceneName_2020: 'scene_B71_10_krs_2020',
    name: 'B71',
    relatedApartments: { 9: 66, 11: 76 },
  },
  {
    floor: 10,
    building: 'B',
    apartmentNumber: 72,
    sceneName: 'scene_B72_10_krs',
    sceneName_2020: 'scene_B72_10_krs_2020',
    name: 'B72',

    relatedApartments: { 9: 67, 11: 77 },
  },
  {
    floor: 10,
    building: 'B',
    apartmentNumber: 73,
    sceneName: 'scene_B73_10_krs',
    sceneName_2020: 'scene_B73_10_krs_2020',
    name: 'B73',
    relatedApartments: { 9: 68, 11: 78 },
  },
]

const FLOOR_11_DATA = [
  {
    floor: 11,
    building: 'B',
    apartmentNumber: 75,
    sceneName: 'scene_B75a_11_krs',
    sceneName_2020: 'scene_B75a_11_krs_2020',
    name: 'B75a',
    relatedApartments: { 10: 70, 12: 100 },
  },
  {
    floor: 11,
    building: 'B',
    apartmentNumber: 76,
    sceneName: 'scene_B76_11_krs',
    sceneName_2020: 'scene_B76_11_krs_2020',
    name: 'B76',
    relatedApartments: { 10: 71, 12: 80 },
  },
  {
    floor: 11,
    building: 'B',
    apartmentNumber: 77,
    sceneName: 'scene_B77_11_krs',
    sceneName_2020: 'scene_B77_11_krs_2020',
    name: 'B77',

    relatedApartments: { 10: 72, 12: 80 },
  },
  {
    floor: 11,
    building: 'B',
    apartmentNumber: 78,
    sceneName: 'scene_B78_11_krs',
    sceneName_2020: 'scene_B78_11_krs_2020',
    name: 'B78',
    relatedApartments: { 10: 73, 12: 81 },
  },
]

const FLOOR_12_DATA = [
  {
    floor: 12,
    building: 'B',
    apartmentNumber: 80,
    sceneName: 'scene_B80_12_krs',
    sceneName_2020: 'scene_B80_12_krs_2020',
    name: 'B80',
    relatedApartments: { 11: 77, 13: 84 },
  },
  {
    floor: 12,
    building: 'B',
    apartmentNumber: 81,
    sceneName: 'scene_B81_12_krs',
    sceneName_2020: 'scene_B81_12_krs_2020',
    name: 'B81',
    relatedApartments: { 11: 78, 13: 85 },
  },
  {
    floor: 12,
    building: 'B',
    apartmentNumber: 100,
    sceneName: 'scene_Kattoterassi_12_krs',
    sceneName_2020: 'scene_Kattoterassi_12_krs_2020',
    name: 'Kattoterassi',
    relatedApartments: { 11: 75, 13: 83 },
  },
]

const FLOOR_13_DATA = [
  {
    floor: 13,
    building: 'B',
    apartmentNumber: 83,
    sceneName: 'scene_B83_13_krs',
    sceneName_2020: 'scene_B83_13_krs_2020',
    name: 'B83',
    relatedApartments: { 12: 100, 14: 87 },
  },
  {
    floor: 13,
    building: 'B',
    apartmentNumber: 84,
    sceneName: 'scene_B84_13_krs',
    sceneName_2020: 'scene_B84_13_krs_2020',
    name: 'B84',
    relatedApartments: { 12: 80, 14: 88 },
  },
  {
    floor: 13,
    building: 'B',
    apartmentNumber: 85,
    sceneName: 'scene_B85_13_krs',
    sceneName_2020: 'scene_B85_13_krs_2020',
    name: 'B85',
    relatedApartments: { 12: 81, 14: 89 },
  },
]

const FLOOR_14_DATA = [
  {
    floor: 14,
    building: 'B',
    apartmentNumber: 87,
    sceneName: 'scene_B87_14_krs',
    sceneName_2020: 'scene_B87_14_krs_2020',
    name: 'B87',
    relatedApartments: { 13: 83 },
  },
  {
    floor: 14,
    building: 'B',
    apartmentNumber: 88,
    sceneName: 'scene_B88_14_krs',
    sceneName_2020: 'scene_B88_14_krs_2020',
    name: 'B88',
    relatedApartments: { 13: 84 },
  },
  {
    floor: 14,
    building: 'B',
    apartmentNumber: 89,
    sceneName: 'scene_B89_14_krs',
    sceneName_2020: 'scene_B89_14_krs_2020',
    name: 'B89',
    relatedApartments: { 13: 85 },
  },
]

export const BUILDING_B_DATA = {
  6: FLOOR_6_DATA,
  7: FLOOR_7_DATA,
  8: FLOOR_8_DATA,
  9: FLOOR_9_DATA,
  10: FLOOR_10_DATA,
  11: FLOOR_11_DATA,
  12: FLOOR_12_DATA,
  13: FLOOR_13_DATA,
  14: FLOOR_14_DATA,
}
